import { Tab } from '@headlessui/react';

const TermInfo = () => {
  return (
    <Tab.Panel as="div" className="flex w-full flex-col gap-y-4">
      <p className="text-center text-2xl font-semibold">Content Policy</p>
      <div className="flex flex-col gap-y-2">
        <ol className="list-custom text-lg font-semibold">
          <li>
            Introduction
            <ol className="text-base font-normal">
              <li>
                Indiemunkey isn&apos;t just a place to read manga; we&apos;re a
                vibrant community for authors, artists, illustrators, writers,
                and fans. Our platform helps creators share their stories and
                connect with global audiences, providing support through
                translations and fan engagement.
              </li>
              <li>
                This Content Policy aims to foster a safe and welcoming
                environment for everyone involved-creators and readers alike.
              </li>
              <li>
                This policy applies to all types of content published on
                Indiemunkey, including manga, comics, graphic novels, light
                novels, and other forms of fiction (&quot;Content&quot;).
              </li>
            </ol>
          </li>
          <li>
            Publishing on Indiemunkey
            <ol className="text-base font-normal">
              <li>
                Indiemunkey includes a self-publishing platform where you can
                publish your Content. To use this feature, you need to create an
                account on our site.
              </li>
              <li>
                You must hold all rights to your Content, ensuring it does not
                infringe on anyone else&apos;s copyright, trademark, or other
                intellectual property rights. You must have the necessary rights
                to publish your Content.
              </li>
              <li>
                By publishing your Content on Indiemunkey, you grant us a
                non-exclusive, royalty-free, worldwide license to host, use,
                copy, reproduce, disclose, publish, broadcast, archive, store,
                cache, publicly display, reformat, translate, and transmit your
                Content for distribution, promotion, and marketing purposes.
                This license allows us to sublicense these rights. The
                distribution can occur through any media formats and channels.
              </li>
              <li>
                This license does not permit Indiemunkey to sell your Content.
              </li>
              <li>
                You can end this license for specific Content by removing it
                from the site or by closing your account. However, this does not
                affect Content already shared or stored by others or the time
                required to remove it from backups.
              </li>
              <li>
                You retain full ownership of your Content and any associated
                intellectual property rights. Indiemunkey is not liable for any
                statements or representations in your Content. You are solely
                responsible for your Content and agree to release us from any
                liability or legal claims related to your Content.
              </li>
              <li>
                We reserve the right to review, re-categorize, or remove any
                Content at our discretion, without notice. We do not actively
                monitor Content.
              </li>
            </ol>
          </li>
          <li>
            Content Guidelines
            <ol className="text-base font-normal">
              <li>
                Prohibited Content
                <ol>
                  <li>
                    Hate Speech: Content that promotes discrimination based on
                    ethnicity, race, gender, sexual orientation, religion, or
                    other social issues.
                  </li>
                  <li>
                    Sexually Explicit Content: Direct depictions of sex organs
                    or sexual acts where such content is the focus of the story.
                  </li>
                  <li>
                    Violent Content: Explicit depictions of gratuitous or
                    excessive violence where it is the focus of the story.
                  </li>
                  <li>
                    Illegal Content: Includes child pornography, child abuse,
                    drug abuse, and other illegal activities.
                  </li>
                  <li>
                    Nazi Imagery: Content that uses Nazi symbols or glorifies
                    related atrocities.
                  </li>
                  <li>
                    Competing Services: Promotion or advertisement of services
                    that directly compete with Indiemunkey.
                  </li>
                  <li>
                    Intellectual Property Infringement: Content that infringes
                    on third-party intellectual property rights.
                  </li>
                  <li>
                    Unlawful Content: Content that is defamatory, misleading,
                    invades privacy, or constitutes harassment.
                  </li>
                  <li>
                    Unsuitable Content: Content that lacks a coherent story or
                    consists of unrelated images.
                  </li>
                </ol>
              </li>
              <li>
                Mature Content
                <ol>
                  <li>
                    Content with implied or indirect depictions of sexual
                    behavior, partial nudity, or excessive violence is allowed
                    but may be categorized as &quot;mature.&quot;
                  </li>
                  <li>
                    Mature Content is not visible by default. Users can enable
                    readability of mature Content in their settings, which
                    require an account and age verification.
                  </li>
                </ol>
              </li>
              <li>
                Restricted Content
                <ol>
                  <li>
                    Content deemed mature but not compliant with App Store or
                    Google Play guidelines will be categorized as
                    &quot;restricted&quot; and will not be accessible via our
                    iOS or Android apps.
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            Reporting ContentReporting Content
            <ol className="text-base font-normal">
              <li>
                Users can report titles or chapters that violate these Content
                Guidelines.
              </li>
              <li>
                Reports will be reviewed manually. If a violation is confirmed,
                the offending Content will be removed.
              </li>
              <li>Repeated violations may result in account suspension.</li>
              <li>
                If your Content is removed or your account is suspended, you can
                contact support for assistance.
              </li>
            </ol>
          </li>
          <li>
            Copyright Infringement
            <ol className="text-base font-normal">
              <li>
                If you believe your copyright has been infringed, send a DMCA
                takedown notice to{' '}
                <span className="text-blue-500">contact@indiemunkey.com</span>.
              </li>
              <li>
                Your notice should include:
                <ol>
                  <li>Proof of copyright ownership or authorization.</li>
                  <li>
                    Details of the copyrighted work and the infringing Content.
                  </li>
                  <li>Specific URLs of the infringing Content.</li>
                  <li>Contact information.</li>
                  <li>
                    Statements confirming good faith belief and accuracy under
                    penalty of perjury.
                  </li>
                  <li>Your name and signature.</li>
                </ol>
              </li>
              <li>
                Upon receipt of a valid notice, we will remove the infringing
                Content and notify the user. If no response is received within
                14 days, the Content will remain removed.
              </li>
              <li>
                If you believe the removal was mistaken, send a counter-notice
                to{' '}
                <span className="text-blue-500">contact@indiemunkey.com</span>.
              </li>
              <li>
                Your counter-notice should include:
                <ol>
                  <li>URL of the removed Content.</li>
                  <li>Contact information.</li>
                  <li>
                    Statements of good faith belief and consent to jurisdiction.
                  </li>
                  <li>Your name and signature.</li>
                </ol>
              </li>
              <li>
                We will forward the counter-notice to the original complainant.
                They have 10 days to file legal action.
              </li>
              <li>
                If no legal action is taken, we may restore the Content after 10
                days at our discretion.
              </li>
            </ol>
          </li>
          <li>
            Questions and Feedback
            <ol className="text-base font-normal">
              <li>
                For questions or feedback about this Content Policy or other
                site concerns, please contact support.
              </li>
            </ol>
          </li>
        </ol>
      </div>
    </Tab.Panel>
  );
};

export default TermInfo;
